<template>
  <e-card @toggleDrag="$emit('toggleDrag')" :class="sizeClasses" data-v-step="3">
    <b-tab title="My Assets" class="e-assets-slider">
      <eb-my-assets></eb-my-assets>
    </b-tab>
    <b-tab title="My Events (Soon)" disabled></b-tab>
    <!-- <b-tab title="Last Seen"></b-tab>
    <b-tab title="Recommended Assets"></b-tab> -->
  </e-card>
</template>

<script>
  import ECard from '../../elements/card/card';
  import EbMyAssets from "@components/widgets/myAssets/myAssets";
  import DynamicSizeMixin from '../../../mixins/dynamicSize';

  export default {
		name: "ec-assets",
    mixins: [DynamicSizeMixin],
    components: {EbMyAssets, ECard},
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/assets/assets.vue